const escapeMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;'
};
const unescapeMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#x27;': "'",
  '&#x60;': '`'
};
const createEscaper = map => {
  const escaper = match => map[match];
  const source = `(?:${Object.keys(map).join('|')})`;
  const testRegexp = RegExp(source);
  const replaceRegexp = RegExp(source, 'g');
  return function (string) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-template-expression
    string = string == null ? '' : `${string}`;
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
};
const escape = createEscaper(escapeMap);
const unescape = createEscaper(unescapeMap);
export { escape, unescape };
//# sourceMappingURL=index.js.map